<template>
  <div>
    <!-- Swiper -->
    <!-- <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(items, index) in contentImageList"
          :key="index"
          :data-href="funcStr(index)"
          :name="index"
        >

          <div
            class="flex"
            :class="contentTbas == index ? 'swipers_home' : 'swipers_home2'"
          >
            <div class="swipers_home_center">
              <img
                :src="contentTbas == index ? items.img : items.img2"
                alt=""
              />
              <p>{{ items.title }}</p>
            </div>
          </div>
          <div class="mc" :name="index"></div>
        </div>
      </div>
      <p class="content_title">{{ contentMess.title }}</p>
      <p class="content_content">
        {{ contentMess.messages }}
      </p>
      <div class="swiper-pagination"></div>
    </div> -->
    <div class="flex platform_box">
      <div
        class="platform"
        v-for="(items, index) in contentImageList"
        :key="index"
        @click="getContentList(index)"
      >
        <div
          class="flex"
          :class="contentTbas == index ? 'swipers_home' : 'swipers_home2'"
        >
          <div class="swipers_home_center">
            <img :src="contentTbas == index ? items.img : items.img2" alt="" />
            <p>{{ items.title }}</p>
          </div>
        </div>
        <!-- <div class="mc" :name="index"></div> -->
      </div>
    </div>

    <p class="content_title">{{ contentMess.title }}</p>
    <p class="content_content">
      {{ contentMess.messages }}
    </p>
    <div class="conIcon flex">
      <i
        v-for="(itemsIcon, index) in contentIcon"
        :key="index"
        :class="index == contentTbas ? 'icons' : ''"
      ></i>
    </div>
  </div>
</template>

<script>
import { getIndexDictionaryData } from "../../utils/interface";
// import Swiper from "Swiper";
import { mapState } from "vuex";

export default {
  name: "swiper",
  components: {},
  data() {
    return {
      // effect: 1,
      // slides: ["Slide 1", "Slide 2", "Slide 3", "Slide 4", "Slide 5"],
      dataHref: "",
      contentList: [],

      contentImageList: [
        {
          title: "数据",
          img: require("../../assets/data.png"),
          img2: require("../../assets/data2.png"),
        },
        {
          title: "设备",
          img: require("../../assets/equipment.png"),
          img2: require("../../assets/equipment2.png"),
        },
        {
          title: "平台",
          img: require("../../assets/office2.png"),
          img2: require("../../assets/office.png"),
        },
        {
          title: "应用",
          img: require("../../assets/application.png"),
          img2: require("../../assets/application2.png"),
        },
        {
          title: "用户",
          img: require("../../assets/user.png"),
          img2: require("../../assets/user2.png"),
        },
      ],

      // 平台是核心
      contentTbas: "2",
      contentTbasIndex: "0",
      conShow: false,
      contentMess: {
        title: "平台是核心",
        messages:
          "平台是企业数字化转型的核心，是连接用户与设备、数据收集、分析、建模的载体，承载了构建丰富多彩的工业互联网应用生态的使命，是实现万物互联的核心",
      },
      contentIcon: [
        {
          icon: "&#xe657;",
        },
        {
          icon: "&#xe657;",
        },
        {
          icon: "&#xe657;",
        },
        {
          icon: "&#xe657;",
        },
        {
          icon: "&#xe657;",
        },
      ],
      setIn: null, // 定时器
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getIndexVocationalWork();
      }
    }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    // this.handSwiper();
  },
  methods: {
    // funcStr(i) {
    //   this.dataHref = i;
    // },
    // handSwiper() {
    //   let effectIn = this.effect;
    //   let that = this;
    //   var swiper = new Swiper(".swiper-container", {
    //     loop: false,
    //     speed: 1000,
    //     slidesPerView: 5,
    //     spaceBetween: 30,
    //     initialSlide: 2,
    //     centeredSlides: true,
    //     watchSlidesProgress: true,
    //     slideToClickedSlide: true,
    //     mousewheel: false,
    //     observer: true,
    //     observeParents: true,
    //     on: {
    //       click: function (swiper, event) {
    //         console.log(swiper.target.attributes.name.value);
    //         that.contentTbas = swiper.target.attributes.name.value;
    //         that.contentList[that.contentTbas].name =
    //           that.contentList[that.contentTbas].name;
    //         that.contentMess.title = that.contentList[that.contentTbas].remarks;
    //         that.contentMess.messages =
    //           that.contentList[that.contentTbas].remarks;
    //       },
    //       setTranslate() {
    //         let slides = this.slides;
    //         for (var i = 0; i < slides.length; i++) {
    //           let slide = slides.eq(i);
    //           let progress = slides[i].progress;
    //           //slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
    //           slide.css({ opacity: "", background: "" });
    //           slide.transform(""); //清除样式

    //           if (effectIn == 1) {
    //             slide.transform("scale(" + (1 - Math.abs(progress) / 8) + ")");
    //           }
    //         }
    //       },
    //       setTransition(transition) {
    //         for (var i = 0; i < this.slides.length; i++) {
    //           var slide = this.slides.eq(i);
    //           slide.transition(transition);
    //         }
    //       },
    //       touchEnd() {
    //         // this.contentTbas = this.activeIndex;
    //       },
    //     },
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true,
    //     },
    //   });
    // },

    getContentList(i) {
      this.contentTbas = i;
      this.contentList[this.contentTbas].name = this.contentList[
        this.contentTbas
      ].name;
      this.contentMess.title = this.contentList[this.contentTbas].value;
      this.contentMess.messages = this.contentList[this.contentTbas].remarks;
      console.log(i);
    },

    getIndexVocationalWork() {
      getIndexDictionaryData({
        groupCode: "PTJS",
      })
        .then((res) => {
          // console.log(res)
          this.contentList = res;

          for (let i = 0; i < res.length; i++) {
            this.contentImageList[i].title = res[i].name;
          }



          this.contentList[this.contentTbas].name = res[this.contentTbas].name;
          this.contentMess.title = res[this.contentTbas].value;
          this.contentMess.messages = res[this.contentTbas].remarks;
          // this.$nextTick(() => {
          //   // 下一个UI帧再初始化swiper
          //   this.handSwiper();
          // });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="less">
.mc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.swiper-container {
  width: 100%;
  height: auto;
  padding: 0 0 100px;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 200px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition-property: all;
}
.platform_box {
  align-items: center;
  justify-content: space-between;
  .platform {
    cursor: pointer;
  }
}
.park_car_img {
  width: 100%;
  height: 200px;
  background: #1181ff;
  border-radius: 10px;
}
.park_swipers {
  .park_swipers_img {
    background: #efefef;
    width: 215px;
    height: 100px;
    border-radius: 10px;
    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-size: 14px;
    color: #777;
    margin-top: 10px;
  }
}
.swiper-slide {
  height: 100%;
  border-radius: 10px;
  background: none;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 250px;
  background: #ffffffb8;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
  top: 32%;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 250px;
  background: #ffffffb8;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
  top: 32%;
}
.swipers_home {
  width: 140px;
  height: 140px;
  background: #c9e1f8;
  border-radius: 50%;
  border: 1px solid #1680f5;
  color: #1680f5;
  align-items: center;
  justify-content: space-between;
  .swipers_home_center {
    img {
      width: 38%;
    }
  }
}
.swipers_home2 {
  width: 120px;
  height: 120px;
  background: #ebebeb;
  border-radius: 50%;
  border: 1px solid #d1d1d1;
  color: #bababa;
  align-items: center;
  justify-content: space-between;
  .swipers_home_center {
    img {
      width: 38%;
    }
  }
}
.content_title {
  font-size: 16px;
  margin: 25px 0 20px;
}
.content_content {
  width: 620px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: lighter;
  color: #808080;
  line-height: 27px;
  // height: 83px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 38px;
}
.conIcon {
  justify-content: center;
  .icons {
    background: #1680f5;
  }
  i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parkSwiper/homeSwiper.vue